// initial state
export const initialState= null;
// create readucer function
export const reducer =(state,action)=>{
    if(action.type === "USER"){
        return action.payload
    }
    return state;
}